<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar"  v-if="avatar"/>
         <el-select
            style="margin-left:8px;"
            v-model="hospital.hospitalId"
            placeholder="全部医疗机构数据"
            @change="setHospitalId"
          >
            <el-option
              v-for="item in hospitals"
              :key="item.hospitalId"
              :label="item.hospitalName"
              :value="item.hospitalId"
            />
          </el-select>
      <!--   <span>{{hospital.hospitalName}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;</span> -->
          <span style="margin-left:8px;">{{userName}}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logOut" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { login, logout } from "@/api/login";
import { hospitalList } from "@/api/dataCenter";

export default {
  data() {
    return {
      userName: null,
      hospitals: [],
      hospital: {
        hospitalId: null,
        hospitalName:null,
      },
      isLogin:'',
    };
  },
  created() {
    this.userName = localStorage.getItem("username");
	  this.isLogin = localStorage.getItem('islogin');
    //this.hospital.hospitalName = localStorage.getItem("hospitalName");
    console.log('hospitalName:',localStorage.getItem("hospitalName"));
    this.getHospitalList();
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "username"])
  },
  methods: {
    setHospitalId() {
      sessionStorage.setItem("hospitalId", this.hospital.hospitalId);
      location.reload();
    },
    getHospitalList() {
      this.listLoading = true;
      hospitalList().then(response => {
        this.listLoading = false;
        this.hospitals = response.data.data;
        console.log(this.isLogin,'this.isLogin')
        // 1.localStorage查找有无hospitalid
        // 2.判断返回列表中是否有这个hospitalid
        // 3.有就默认选中这个hospitalid
        // 4.没有就默认选中第一个
        if(!this.hospitals || this.hospitals.length <= 0) {
          // this.$message()
          return
        }

        let tempHospitalId = parseInt(sessionStorage.getItem("hospitalId") || 0)
        if (!!tempHospitalId) {
          let conditionHasIt = this.hospitals.filter((item) => {
            return item.hospitalId == tempHospitalId;
          });

          if(conditionHasIt.length > 0) {
            this.hospital.hospitalId = tempHospitalId;
          } else {
            this.hospital.hospitalId = this.hospitals[0].hospitalId;
            sessionStorage.setItem("hospitalId", this.hospital.hospitalId);
          }
        } else {
          this.hospital.hospitalId = this.hospitals[0].hospitalId;
          sessionStorage.setItem("hospitalId", this.hospital.hospitalId);
        }
      });
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logOut() {
      /*this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })*/
      console.log(sessionStorage.getItem("username"));
      sessionStorage .removeItem("username");
      console.log(sessionStorage.getItem("username"));
      localStorage.removeItem('token');
      localStorage.removeItem('islogin');
      console.log('isAdmin'+localStorage.getItem('isAdmin'));
       this.$router.push({ path: "/login" });
   
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue